<form action="" class="w-100">
  <div class="form-check w-100 d-flex justify-content-between align-items-center">
    <h4 class="w-100 pb-2 border-bottom text-center text-secondary" for="exampleRadios1">
      Select your city
    </h4>
  </div>

  <div class="inputGroup" *ngFor="let item of cities; let i=index">
    <input id="radio{{i}}" name="radio" type="radio" [(ngModel)]="selectedCity" value="{{item.id}}" />
    <label for="radio{{i}}">{{item.name}}</label>
  </div>
  <!-- <div class="inputGroup">
        <input id="radio2" name="radio" type="radio" />
        <label for="radio2">Vapi</label>
      </div> -->

  <div class="text-center py-2" *ngIf="selectedCity" (click)="goNext()">
    <button class="btn btn-add text-white" type="button">
      Select
    </button>
  </div>
</form>